import * as React from "react"
import { Fragment } from "react";
import { useAppToast } from "@ui-seeker/app"
import { batch, useSignal } from "@preact/signals-react"
import { InputAdornment, Box, Link, Button, styled, CircularProgress, Typography } from "@mui/material"
import { getSubmit, postSubmit, fileSubmit } from "@ui-seeker/utils"

import { 
	ButtonIconSeeker, PopoverSeeker, PopoverSeekerItem, ButtonLoadingSeeker, TextFieldSeeker, 
	ToggleButtonSeeker, ButtonSeeker, TagFieldSeeker, IconSeeker
} from "@ui-seeker/core"

import { sku, isOpenSkuGroupModal, brand, retailer, country } from "@signals"
import { useSkuGroupModal } from '@hooks'
import { useRef } from "react";
import { BACKEND_APIS } from "@constants";
import { FindSkusPopover } from "./@components";


const TABS_VALUE = {
	UPLOAD: 'upload',
	WRITE: 'write',
}

const TABS = [
	{ value: TABS_VALUE.UPLOAD, label: 'Upload' },
	{ value: TABS_VALUE.WRITE, label: 'Write' }
]

const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
  });

export default function DIPSkuInputAdornment({ skuOptions, isLoading=false }) {

    const { getSkuGroupList } = useSkuGroupModal()
    const iconWeight = useSignal('regular')
	const anchorEl = useSignal(false)

	return <InputAdornment position="end">
		{isLoading && <CircularProgress size={14} sx={{ position: 'absolute', right: 43, color: 'primary.dark' }} />}
		<FindSkusPopover anchorEl={anchorEl} iconWeight={iconWeight} skuOptions={skuOptions} />

		<ButtonIconSeeker 
			disabled={!sku.value?.length}
			icon='floppy-disk' 
			iconWeight={iconWeight}
			onMouseOver={() => iconWeight.value = 'solid'}
			onMouseLeave={() => iconWeight.value = 'regular'}
			onClick={() => {
				getSkuGroupList()
				isOpenSkuGroupModal.value = true
			}}
			tooltip="Save SKU Group" 
			sx={{ m: 0, position: 'absolute', top: 'calc(50% - 20px)', right: 55, fontSize: '1.5rem', '&:hover': { cursor: 'pointer' } }}
			iconProps={
				{ color: !sku.value?.length ? 'divider' : 'info.light' }
			}
		/>

	</InputAdornment>
}